<script setup lang="ts">
import { VueQueryDevtools } from '@tanstack/vue-query-devtools';
import { watch } from 'vue';
import { RouterView } from 'vue-router';

// components
import PromptReload from '~/components/system/ReloadPrompt.vue';
// hooks
import useSearchParams from '~/hooks/useSearchParams';
// services
import keycloakApi from '~/services/keycloack-api/keycloack-api';
// store
import useAuth from '~/store/auth/useAuth';
import useLogin from '~/store/auth/useLogin';

const [searchParams] = useSearchParams();

const code = searchParams.value.get('code');

const {
  isError: isAuthError,
  isLoading: isAuthLoading,
} = useAuth();

const {
  error: loginError,
  isError: isLoginError,
  isPending: isLoginPending,
  mutateAsync: handleLogin,
} = useLogin();

async function handleAuthError() {
  if (!code) return keycloakApi.redirect();

  return handleLogin(code)
    .catch(keycloakApi.redirect)
    .finally(keycloakApi.cleanUrlParams);
}

watch([isAuthLoading, isAuthError], async () => {
  if (isAuthLoading.value) return;

  if (isAuthError.value) {
    await handleAuthError();
  }

  keycloakApi.cleanUrlParams();
});
</script>

<template>
  <VueQueryDevtools />

  <div class="centered" v-if="isAuthLoading">
    <p>Carregando sua sessão...</p>
  </div>

  <div class="centered" v-else-if="isLoginPending">
    <p>Autenticando...</p>
  </div>

  <div class="centered" v-else-if="isLoginError">
    <p>Erro ao fazer login: {{ loginError?.message }}</p>
  </div>

  <div class="centered" v-else-if="isAuthError">
    <p>Aguarde. Redirecionando..</p>
  </div>

  <div v-else>
    <PromptReload />
    <RouterView />
  </div>
</template>

<style scoped>
  .centered {
    display: grid;
    place-items: center;
    height: 100dvh;
  }
</style>
